import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const SuiteHeader = () => import(/* webpackChunkName: "4-feat-suiteheader" */ './SuiteHeaderBoundary');

export default lazyLoadOnRender({ loader: SuiteHeader });
